import "./WatchlistWidgetComponent.scss";
import template from "./WatchlistWidgetComponent.html";
import {IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {BehaviorSubject, ReplaySubject} from "rxjs";
import {WatchlistId} from "../../../../../watchlist/models/WatchlistId";
import {isNotNull} from "../../../../../js/util/UtilFunctions";
import {WatchlistWidgetConfig} from "./models/WatchlistWidgetConfig";
import {ComponentCallback} from "../../../../../types/AngularJS";
import {CodeAndExchange} from "app/instruments/types/CodeAndExchange";
import {WidgetDisplayMode} from "../../../models/WidgetDisplayMode";

export const WatchlistWidget = "tfWatchlistWidget";

export function watchlistWidget(): IComponentOptions {
    return {
        template,
        bindings: {
            config: "<",
            displayMode: "<",
            onSecurityChanged: "&",
            onConfigChanged: "&"
        },
        controllerAs: "ctrl",
        controller: WatchlistWidgetController
    };
}

export class WatchlistWidgetController implements IOnInit, IOnDestroy {

    /** @input */
    public set config(config: WatchlistWidgetConfig | null) {
        if (config != null) {
            this.config$.next(config);
        }
    }

    private readonly config$ = new BehaviorSubject<WatchlistWidgetConfig | null>(null);

    /** @input */
    public set displayMode(displayMode: WidgetDisplayMode | null) {
        if (displayMode != null) {
            this.wide = displayMode === WidgetDisplayMode.WIDE;
        } else {
            this.wide = false;
        }
    }

    public wide = false;

    /** @output */
    public readonly onSecurityChanged: ComponentCallback;

    /** @output */
    public readonly onConfigChanged: ComponentCallback;

    public readonly selected$ = new ReplaySubject<WatchlistId | null>();

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    public $onInit(): void {
        this.watchConfig();
        this.watchSelected();
    }

    private watchConfig() {
        this.config$
            .takeUntil(this.destroyed$)
            .filter(isNotNull)
            .map((c) => c.selected)
            .distinctUntilChanged()
            .subscribe((selected) => this.selected$.next(selected));
    }

    private watchSelected() {
        this.selected$
            .takeUntil(this.destroyed$)
            .distinctUntilChanged()
            .withLatestFrom(this.config$)
            .map(([selected, config]) => this.updateConfig(selected, config))
            .subscribe((config) => this.onConfigChanged({config}));
    }

    private updateConfig(selected: WatchlistId | null, config: WatchlistWidgetConfig | null): WatchlistWidgetConfig {
        if (config == null) {
            return {selected};
        } else {
            return {...config, selected};
        }
    }

    public selectionChanged(id: WatchlistId) {
        this.selected$.next(id);
    }

    public itemClicked(security: CodeAndExchange) {
        this.onSecurityChanged({security});
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
